"use client"

import { Menu } from "lucide-react"
import { useSidebar } from "@workspace/ui/components/shadcn/sidebar"

export function SidebarToggleButton() {
    const { toggleSidebar } = useSidebar()

    return (
        <button
            type="button"
            onClick={toggleSidebar}
            className="w-8 h-8 flex items-center justify-center bg-transparent border-none shadow-none p-0 hover:bg-transparent focus:outline-none"
            aria-label="Toggle sidebar"
        >
            <Menu size={20} />
        </button>
    )
}
